export const PIXEL_CONSTANTS = {
  twelve: '12px',
  fourteen: '14px',
  sixteen: '16px',
  eighteen: '18px',
  twentyone: '21px',
  twentyfour: '24px',
};
